(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coupon-drawer')) {
    customElements.define(
      'coupon-drawer',
      class CouponDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.openButton = this.querySelector('[data-coupon-open]');
          this.closeButton = this.querySelector('[data-coupon-close]');
          this.status = this.querySelector('[data-coupon-status]');
          this.openButton?.addEventListener('click', () => this.dialog?.showModal());
          this.closeButton?.addEventListener('click', () => this.dialog?.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.querySelectorAll('[data-coupon-code]').forEach((button) => {
            button.addEventListener('click', () => this.copyCode(button));
          });
        }

        async copyCode(button) {
          const code = button.dataset.couponCode;
          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }
          button.textContent = button.dataset.copiedLabel;
          if (this.status) this.status.textContent = button.dataset.copiedLabel;
          window.setTimeout(() => {
            button.textContent = button.dataset.copyLabel;
          }, 1500);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
